// import createClient from '@sgorg/ga-client';
import { PrintType } from 'js/crossword/html/types';
import { RevealType } from 'js/crossword/types';
import { getPublisherId } from 'js/crossword/sdk/getPublisherId';

// const gaTrackingId = 'UA-181666030-1'; // The GA tracking ID

// const gaClient = createClient({
//   gaTrackingId,
// });

enum Category {
  Partner = 'Partner',
  GameFlow = 'GameFlow',
  PressTopMenuButton = 'PressTopMenuButton',
  PrintPuzzle = 'PrintPuzzle',
  ChangeSettings = 'ChangeSettings',
  PickDate = 'PickDate',
  WatchAdToReveal = 'WatchAdToReveal',
}

export enum GameFlowEvent {
  StartPuzzle = 'StartPuzzle',
  CompletePuzzle = 'CompletePuzzle',
}

export enum TopMenuButtonType {
  Pause = 'Pause',
  RevealLetter = 'RevealLetter',
  RevealWord = 'RevealWord',
  RevealPuzzle = 'RevealPuzzle',
  Autocheck = 'Autocheck',
  CheckLetter = 'CheckLetter',
  CheckWord = 'CheckWord',
  CheckPuzzle = 'CheckPuzzle',
  ClearWord = 'ClearWord',
  ClearPuzzle = 'ClearPuzzle',
  ClearPuzzleAndTimer = 'ClearPuzzleAndTimer',
  ZoomIn = 'ZoomIn',
  ZoomOut = 'ZoomOut',
  Print = 'Print',
  Calendar = 'Calendar',
  Settings = 'Settings',
}

export function trackGameFlow(event: GameFlowEvent): void {
  track(Category.GameFlow, event);
}

export function trackPartner(): void {
  track(Category.Partner, getPublisherId().toString());
}

export function trackRevealAd(type: RevealType): void {
  track(Category.WatchAdToReveal, type);
}

export function trackPickDateCalendarPlay(): void {
  track(Category.PickDate, 'CalendarPlay');
}

export function trackPickDateBackToCalendar(): void {
  track(Category.PickDate, 'BackToCalendar');
}

export function trackPickDateLoadPuzzle(): void {
  track(Category.PickDate, 'LoadPuzzle');
}

export function trackMenuButton(button: TopMenuButtonType): void {
  track(Category.PressTopMenuButton, button);
}

export function trackPrint(type: PrintType): void {
  track(Category.PrintPuzzle, type);
}

function track(category: string, action: string): void {
  console.log(`TRACK ${category} ${action}`);
  // gaClient.trackEvent({
  //   category,
  //   action,
  // });
}
